export class ServerMessage {
    public static readonly TOPIC_GAMESERVER: string = 'gameserver';
    public static readonly TOPIC_POPUP: string = 'popup';
    public static readonly TOPIC_REALITYCHECK: string = 'realitycheck';
    public static readonly TOPIC_BALANCEUPDATE: string = 'balanceupdate';
    public static readonly TOPIC_CONNECTION_ERROR: string = 'error/connection/error';
    public static readonly TOPIC_CONNECTION_TIMEOUT: string = 'error/connection/timeout';
    public static readonly TOPIC_CONNECTION_SLOW: string = 'warning/connection/slow';
    public static readonly TOPIC_GAMESERVER_ERROR: string = 'gameserver/error';

    public topic!: string;
    public status!: string;
    public data: any;
}